import {SearchResultItem, SearchResultResponse, SiteSearchConfig} from "../../empracoTypes";
import {ISearchRequest} from "./site-search";

export enum SearchType {
  umbracoContent = 1,
  product,
  vehicle
}

interface SearchEndpoint {
  url: string;
  type: SearchType;
  active: boolean;
  method: string;
  headers?: Record<string, string>;
  body?: string;
}

export interface GroupedResponse extends SearchResultResponse<SearchResultItem> {
  type: SearchType;
}

function getEndpointItems(config: SiteSearchConfig, req: ISearchRequest): SearchEndpoint[] {  
  req.pageSize = window.innerWidth <= 800 ? 4 : req.pageSize ?? 10;
  
  return [
    {
      url: '/umbraco/EmporiApi/PrimeflowSearch/Search',
      type: SearchType.product,
      active: config.primeflow?.enabled,
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(req)
    },
    {
      url: `${config.onlineShowroom?.apiBaseUrl}?searchText=${req.searchTerm}&max=${req.pageSize}`,
      type: SearchType.vehicle,
      active: config.onlineShowroom?.enabled,
      method: 'GET'
    },
    {
      url: `/umbraco/EmporiApi/PrimeflowSearch/SearchCategories?searchTerm=${req.searchTerm}&max=${req.pageSize}`,
      type: SearchType.umbracoContent,
      active: config.primeflow?.enabled,
      method: 'GET'
    },
    {
      url: '/umbraco/EmporiApi/SearchApi/Search',
      type: SearchType.umbracoContent,
      active: true,
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(req)
    }
  ]
}

export async function fetchMultiple(config: SiteSearchConfig, req: ISearchRequest) {
    
  const results = await Promise.allSettled(
    getEndpointItems(config, req).filter(item => item.active).map(async item => {      
      const res = await fetch(item.url, { ...item });
      
      const json = await res.json() as SearchResultResponse<SearchResultItem>;
      
      if (json && item.type === SearchType.vehicle) {
        return {
          totalCount: (json as any).total,
          searchTerm: req.searchTerm,
          results: (json as any).items,
          type: item.type
        }
      }
      
      return json ? {...json, type: item.type} : null;
    })
  );
  
  const response: GroupedResponse[] = [];
  
  // Process results.
  for (const result of results) {
    if (result.status === 'fulfilled') {
      const resultData = result.value;
      
      if (resultData) {        
        response.push({
          totalCount: resultData.totalCount,
          searchTerm: req.searchTerm,
          results: resultData.results,
          type: resultData.type
        })
      }
    }
  }

  // Merge results with the same type.
  const mergedResponse = Object.values(
    response.reduce((acc: any, item) => {
      if (!acc[item.type]) {
        acc[item.type] = { ...item };
      } else {
        acc[item.type].totalCount += item.totalCount;
        acc[item.type].results.push(...item.results);
      }
      return acc;
    }, {})
  );
  
  return mergedResponse as GroupedResponse[];
}